import { computed, ref, watch } from 'vue';
import deepEqual from 'lodash/isEqual';

export function useFilterDrawer(savedFiltersParam, filters, drawerActiveParam) {
  const savedFilters = savedFiltersParam;
  const drawerActive = drawerActiveParam;

  const pendingFilters = ref({ ...(savedFilters.value || {}) });
  const isUpdated = ref(false);

  function isEmptyFilter(object) {
    return object === null || object === undefined
            || (Array.isArray(object) && object.length === 0)
            || object === '';
  }

  function removeEmptyFilters(filtersParam, withDynamicOverride) {
    const newFilters = {};
    Object.keys(filtersParam || {}).forEach((key) => {
      if (isEmptyFilter(filtersParam[key]?.value)) return;

      const definition = filters.value.find((filter) => filter.key === key);
      if (!definition) return;
      if (definition.dynamic && Array.isArray(filtersParam[key].value) && withDynamicOverride) {
        if (withDynamicOverride && !filtersParam[key].value.some((element) => !isEmptyFilter(element.value))) {
          return;
        }
      }

      newFilters[key] = { value: filtersParam[key].value };
    });
    return newFilters;
  }

  watch(drawerActive, (newValue) => {
    if (newValue) {
      pendingFilters.value = { ...savedFilters.value };
      isUpdated.value = false;
    }
  });

  const updatePending = (filtersParam) => {
    pendingFilters.value = Object.keys(removeEmptyFilters(filtersParam)).reduce((acc, key) => {
      const accAux = acc;
      if (typeof filtersParam[key] === 'object' && filtersParam[key].value) accAux[key] = filtersParam[key];
      if (typeof filtersParam[key] !== 'object' && filtersParam[key]) accAux[key] = filtersParam[key];
      return accAux;
    }, {});
    isUpdated.value = true;
  };

  const resetFilters = () => {
    pendingFilters.value = {};
    isUpdated.value = true;
  };

  function close() {
    drawerActive.value = false;
    resetFilters();
  }

  const save = (onClose) => {
    savedFilters.value = { ...pendingFilters.value };
    if (typeof onClose === 'function') onClose();
    drawerActive.value = false;
  };

  const isSaveDisabled = computed(() => {
    return deepEqual(removeEmptyFilters(pendingFilters.value, true), removeEmptyFilters(savedFilters.value, true));
  });

  const isResetDisabled = computed(() => {
    return Object.keys(pendingFilters.value).length === 0;
  });

  return { resetFilters, isResetDisabled, isSaveDisabled, updatePending, save, close, pendingFilters };
}
